import Vue from "vue";
import Vuex from "vuex";
import router from "../../routes";
import ApiService from "../../services/api.services";
import { TokenService, leaveImpersonation } from "../../services/auth/storage.services.js";
import {
  AuthenticationError,
  UserService,
} from "../../services/users/user.services";

Vue.use(Vuex);

const state = {
  authenticating: false,
  accessToken: TokenService.getToken(),
  loggedIn: TokenService.getToken() ? true : false,
  authenticationErrorCode: 0,
  authenticationError: "",
};

const getters = {
  loggedIn: (state) => {
    return state.accessToken ? true : false;
  },

  authenticationErrorCode: (state) => {
    return state.authenticationErrorCode;
  },

  authenticationError: (state) => {
    return state.authenticationError;
  },

  authenticating: (state) => {
    return state.authenticating;
  },
};

const actions = {
  async login({ commit }, { email, password }) {
    try {
      const token = await UserService.login(email, password);
      commit("loginSuccess", token);
      state.accessToken = token;
      TokenService.saveToken(token);
      ApiService.setHeader(token);
      return true;
    } catch (e) {
      if (e instanceof AuthenticationError) {
        commit("loginError", {
          errorCode: e.errorCode,
          errorMessage: e.message,
        });
      }
      throw e;
    }
  },

  logout({ commit }) {
    if (TokenService.isImpersonating()) {
      return leaveImpersonation();
    }
    UserService.logout();
    commit("logoutSuccess");
    Vue.prototype.$bus.$emit("logout", "User logout");
    router.replace({
      name: "login",
    });
  },
};

const mutations = {
  loginRequest(state) {
    state.authenticating = true;
    state.authenticationError = "";
    state.authenticationErrorCode = 0;
  },

  loginSuccess(state, accessToken) {
    state.accessToken = accessToken;
    state.authenticating = false;
  },

  loginError(state, { errorCode, errorMessage }) {
    state.authenticating = false;
    state.authenticationErrorCode = errorCode;
    state.authenticationError = errorMessage;
  },

  logoutSuccess(state) {
    state.accessToken = null;
  },
};

const auth = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default auth;

export { auth };
